module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai38-09112eb931b4bf7f03ff3e2710c210fb.jpg";